export default {
  A: 'green',
  F: 'cyan',
  B: 'blue',
  O: 'gold',
  D: 'red',
  I: 'default', // Default
  E: 'magenta', // Experiência
};
